<template>
  <div class="account-container">
    <div class="account-header">
      账号管理
    </div>
    <div class="account-content"
         v-if="userInfo">
      <div class="item username">
        <div class="label">用户名</div>
        <div class="content">{{ userInfo.userName }}</div>
      </div>
      <div class="item name">
        <div class="label">姓名/企业名称</div>
        <div class="content">{{ userInfo.accountName }}</div>
      </div>
      <div class="item mobile">
        <div class="label">手机号</div>
        <div class="content">
          <span class="detail">{{ userInfo.phoneNumber }}</span>
          <span class="tips">仅自己可见</span>
        </div>
      </div>
      <div class="item email">
        <div class="label">邮箱</div>
        <div class="content"
             v-if="userInfo.emailAddress">
          <div class="detail">{{ userInfo.emailAddress }}</div>
          <div class="tips">仅自己可见</div>
        </div>
        <div class="content"
             v-else>--</div>
      </div>
      <div class="item QQ">
        <div class="label">QQ</div>
        <div class="content"
             v-if="!isEditQQ">
          <span class="detail">{{ userInfo.qq }}</span>
          <span class="editQQ"
                @click="editQQ">修改</span>
        </div>
        <div class="content"
             v-else>
          <el-input size="mini"
                    v-model="qq"
                    clearable
                    @input="validateQQ"></el-input>
        </div>
      </div>
    </div>
    <el-button :type="saveBtnType"
               class="save-btn"
               size="small"
               v-if="isEditQQ"
               @click="saveEdit">保存</el-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userInfo: this.$store.state.userInfo,
      isEditQQ: false,
      qq: '',
      isValidatePass: true
    };
  },
  beforeCreate () {
    this.$store.commit('setActiveIndex', '/account')
    this.$store.commit('setSubActiveIndex', '/account')
    this.$store.commit('setAsideWidth', 300)
  },
  created () {
  },
  computed: {
    saveBtnType () {
      return (this.isValidatePass ? 'primary' : 'info')
    }
  },
  methods: {
    editQQ () {
      this.isEditQQ = true
      const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
      this.qq = userInfo.qq
    },
    validateQQ (e) {
      let reg = /^[1-9][0-9]{4,9}$/
      this.isValidatePass = reg.test(e)
    },
    saveEdit () {
      if (!this.isValidatePass) {
        return this.$message.error('请输入正确的QQ号')
      }
      const params = {
        id: this.userInfo.id,
        qq: this.qq,
        accountName: this.userInfo.accountName,
        accountDescribe: this.userInfo.accountDescribe
      }
      this.$http.put('/api/services/inquiryApp/account/UpdateAccount', params)
        .then(res => {
          this.$store.state.userInfo.qq = this.qq
          this.isEditQQ = false
          this.$message.success('修改成功！')
        })
        .catch(err => {
          console.log(err);
        })
    }
  },
};
</script>
<style lang="less" scoped>
.account-container {
  width: 100%;
  min-width: 1200px;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.account-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.account-content {
  margin-top: 15px;
  font-size: 14px;
  .item {
    height: 45px;
    display: flex;
    align-items: center;
    .label {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      color: #b7bbc8;
    }
    .content {
      display: flex;
      align-items: center;
      color: #2f343c;
      .detail {
        margin-right: 20px;
      }
      .tips {
        color: #b7bbc8;
      }
      .editQQ {
        color: #027cff;
        cursor: pointer;
      }
    }
  }
}
.save-btn {
  margin-left: 100px;
}
</style>